import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Only the default (en) bundle is shipped in the main chunk. The other
// locales are far less commonly used, so we lazy-load them on demand
// (when the user actually switches language). This keeps ~73KB of JSON
// off the critical path => smaller main bundle, lower TBT.
import enTranslation from './locales/en/translation.json';

const lazyLoaders = {
  es: () => import('./locales/es/translation.json'),
  zh: () => import('./locales/zh/translation.json'),
  vi: () => import('./locales/vi/translation.json'),
  ar: () => import('./locales/ar/translation.json'),
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
    },
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

// Fetch + register a non-en locale bundle the first time it's needed.
async function ensureLanguageLoaded(lng) {
  const base = (lng || '').split('-')[0];
  if (!base || base === 'en') return;
  const loader = lazyLoaders[base];
  if (!loader || i18n.hasResourceBundle(base, 'translation')) return;
  try {
    const mod = await loader();
    i18n.addResourceBundle(base, 'translation', mod.default || mod, true, true);
    // Re-apply so components re-render now that the bundle is available.
    if ((i18n.language || '').split('-')[0] === base) {
      i18n.changeLanguage(i18n.language);
    }
  } catch {
    // fall back to en silently
  }
}

i18n.on('languageChanged', ensureLanguageLoaded);
// Handle the case where the detector resolved to a non-en language on first load.
ensureLanguageLoaded(i18n.language);

export default i18n;
